import * as THREE from 'three'

// 源文件生成器，产出一个blob
function SourceExporter() {
}

function getMeshSize(mesh) {
    let position = mesh.geometry.attributes.position;
    let indices = mesh.geometry.index;

    let n_bytes = 4; // n_vertices
    n_bytes += position.array.length * 4; // vertices  float[]
    n_bytes += 4; // n_faces
    n_bytes += indices === null ? 0 : indices.array.length * 4; // index  int[]

    return n_bytes;
}

function writeMesh(mesh, writer, index) {
    mesh.updateWorldMatrix(false, false);
    let m = mesh.matrixWorld;

    let position = mesh.geometry.attributes.position;
    let indices = mesh.geometry.index;

    writer.setInt32(index, position.count, true);
    index += 4;
    let v = new THREE.Vector3();
    for (let i = 0; i < position.count; i++) {
        v.fromBufferAttribute(position, i);
        v.applyMatrix4(m);
        writer.setFloat32(index, v.x, true);
        index += 4;
        writer.setFloat32(index, v.y, true);
        index += 4;
        writer.setFloat32(index, v.z, true);
        index += 4;
    }
    writer.setInt32(index, indices ? indices.count / 3 : 0, true);
    index += 4;
    if (indices) {
        for (let i = 0; i < indices.array.length; i++) {
            writer.setInt32(index, indices.array[i], true);
            index += 4;
        }
    }

    return index;
}

// 生成blob
SourceExporter.prototype.makeBlob = function (group) {
    group.updateWorldMatrix(false, true);
    let hair = group.children[0].children[0];
    let head = group.children[1];
    console.log(hair, head);
    
    // 写入头发数据
    let n_bytes = getMeshSize(hair) + getMeshSize(head);

    // 创建数组和输出器
    let buffer = new ArrayBuffer(n_bytes);
    let writer = new DataView(buffer);

    let index = 0;
    index = writeMesh(hair, writer, index);
    index = writeMesh(head, writer, index);

    return new Blob([buffer], { type: "application/octet-binary" });
}

export default SourceExporter;



// WEBPACK FOOTER //
// ./src/views/headPortrait3d/scripts/SourceExporter.js